<template>
  <div>
    <HistoryLogCom :fullNode="fullNode"/>

    <el-table :data="fullNode.project_node.node_result.full_list"
              class="issue-invoice-table"
              border>
      <el-table-column prop="collection_id"
                       label="回款单ID"
                       min-width="80">
        <template slot-scope="scope">
          <a :href="`/received-payment/detail/${scope.row.collection_id}`" target="_blank">
            {{scope.row.collection_id}}
          </a>
        </template>
      </el-table-column>
      <el-table-column prop="receipt_apply_id"
                       label="开票单ID"
                       min-width="80">
        <template slot-scope="scope">
          <a :href="`/invoice-apply/detail/${scope.row.receipt_apply_id}?type=detail&from=apply`" target="_blank">
            {{scope.row.receipt_apply_id}}
          </a>
        </template>
      </el-table-column>
      <el-table-column prop="received_date"
                       label="回款日期"
                       min-width="100"/>
      <el-table-column prop="submit_admin"
                       label="回款操作人"
                       min-width="100">
        <template slot-scope="scope">
          {{ scope.row.creator_name }}/{{ scope.row.creator_id }}
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>

import HistoryLogCom from '@views/project/node-views/HistoryLogCom.vue'

export default {
  components: {HistoryLogCom},
  mixins: [],
  props: {
    fullNode: {
      type: Object,
      default: () => {},
    },
    projectId: {
      type: String,
      default: '0',
    }
  },
  data () {
    return {}
  },
  created () {},
  computed: {},
  watch: {},
  methods: {},
}
</script>



// WEBPACK FOOTER //
// src/views/project/node-views/PaymentReceiveView.vue